import { createBrowserHistory } from "history";
export const crmHistory = createBrowserHistory();
export const push = (path: string, state?: unknown) => crmHistory.push(path, state);
